/* eslint-disable no-param-reassign */
import produce from 'immer';

import { OLD_URL, INFO_PAY, STATE_CYCLE, IS_OPEN_POPUP, DISPLAY_OFFLINE_PAYMENT, IS_BUSY, IS_CALLED, ACTIVEUPDATE, WIDTH_SIDEBAR, IS_LOADING_ASSIGN_CAR, INFO_DRIVER_TO_CAR, LISTVEHICLE} from '../actions/busyActions';

const initialState = {
  isBusy: null,
  isCalled: false,
  isUpdate: false,
  sizeSideBar: null,
  isLoadingAssignCar: null,
  driverToCar: null,
  listVehicle: null,
  displayOffline: null,
  isOpenPopup: null,
  cycleManager: null,
  infoPay: null,
  oldUrl: null,
};

const busyReducer = (state = initialState, action) => {
  switch (action.type) {
    case IS_BUSY: {
      const { isBusy } = action.payload;
      return produce(state, (draft) => {
        draft.isBusy = isBusy;
      });
    }

    case LISTVEHICLE: {
      const { listVehicle } = action.payload;
      return produce(state, (draft) => {
        draft.listVehicle = listVehicle;
      });
    }

    case IS_CALLED: {
      const { isCalled } = action.payload;
      return produce(state, (draft) => {
        draft.isCalled = isCalled;
      });
    }

    case ACTIVEUPDATE: {
      const { isUpdate } = action.payload;
      return produce(state, (draft) => {
        draft.isUpdate = isUpdate;
      });
    }

    case WIDTH_SIDEBAR: {
      const { sizeSideBar } = action.payload;
      return produce(state, (draft) => {
        draft.sizeSideBar = sizeSideBar;
      });
    }

    case IS_LOADING_ASSIGN_CAR: {
      const { isLoadingAssignCar } = action.payload;
      return produce(state, (draft) => {
        draft.isLoadingAssignCar = isLoadingAssignCar;
      });
    }

    case INFO_DRIVER_TO_CAR: {
      const { driverToCar } = action.payload;
      return produce(state, (draft) => {
        draft.driverToCar = driverToCar;
      });
    }

    case IS_OPEN_POPUP: {
      const { isOpenPopup } = action.payload;
      return produce(state, (draft) => {
        draft.isOpenPopup = isOpenPopup;
      });
    }
      
    case DISPLAY_OFFLINE_PAYMENT: {
      const { displayOffline } = action.payload;
      return produce(state, (draft) => {
        draft.displayOffline = displayOffline;
      });
    }

    case STATE_CYCLE: {
      const { cycleManager } = action.payload;
      return produce(state, (draft) => {
        draft.cycleManager = cycleManager;
      });
    }

    case INFO_PAY: {
      const { infoPay } = action.payload;
      return produce(state, (draft) => {
        draft.infoPay = infoPay;
      });
    }

    case OLD_URL: {
      const { oldUrl } = action.payload;
      return produce(state, (draft) => {
        draft.oldUrl = oldUrl;
      });
    }

    default: {
      return state;
    }
  }
};

export default busyReducer;
